import { render, staticRenderFns } from "./openChatDialog.vue?vue&type=template&id=63b875c4&scoped=true&"
import script from "./openChatDialog.vue?vue&type=script&lang=js&"
export * from "./openChatDialog.vue?vue&type=script&lang=js&"
import style0 from "./openChatDialog.vue?vue&type=style&index=0&id=63b875c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b875c4",
  null
  
)

export default component.exports